import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export default function DToastHeader({ children, className, style }) {
    return (_jsx("div", { className: classNames('toast-header', className), style: style, children: children }));
}
//# sourceMappingURL=DToastHeader.js.map